<template>
  <!-- container -->
  <div class="container mx-auto md:mx-0 p-8 md:p-12 md:w-2/3">
    <!-- Sign out  -->
    <div class="flex justify-end">
      <div class="flex flex-row text-gray-800 cursor-pointer" @click="signOut">
        <div class="md:visible invisible text-gray-600">
          {{ $t("buttons.signOut") }}
        </div>
        <font-awesome-icon color="grey" icon="sign-out-alt" class="ml-3 mt-1" />
      </div>
    </div>
    <div
      class="flex flex-col item-center md:items-start justify-center md:justify-start h-full md:pr-64 md:mt-0 mt-10"
    >
      <!-- logo -->
      <div
        class="flex item-center justify-center md:mb-12 mb-6 w-full flex-col md:flex-row"
      >
        <div class="md:w-1/3 md:w-56 w-full flex justify-center">
          <div class="flex flex-col md:mt-10 mt-0">
            <img src="@/assets/icons/logo.svg" />

            <div class="flex flex-row relative justify-center md:w-56">
              <!-- Info icon -->
              <rele-info-tooltip
                icon="info"
                @mouseover="onIconHover"
                @mouseleave="onIconLeave"
                :tooltip-html="$t('signup.info.tooltips.firstIntegration')"
                class="absolute right-0 md:mr-4 mr-12"
              />

              <!-- SIGN UP text -->
              <div
                class="mt-5 text-r-primary text-2xl text-center tracking-widest"
              >
                {{ $t("signup.signup") }}
              </div>
            </div>
          </div>
        </div>

        <!-- steps -->
        <div class="flex w-2/3 w-full md:ml-10 ml-0 mt-8 md:mt-0">
          <rele-auth-steps :current-step="3" style="z-index: -10" />
        </div>
      </div>

      <!-- description -->
      <p v-html="$t('signup.firstIntegrationDescription')" class="mb-6"></p>

      <div class="flex flex-row flex-wrap">
        <rele-new-integration
          v-for="(integration, i) in integrations"
          :key="i"
          class="flex m-4 w-80"
          v-bind="integration"
        />
      </div>
    </div>

    <!-- right side of the screen with the image -->
    <div
      :style="{ backgroundImage: `url(${bgUrl})` }"
      class="hidden md:block w-1/3 absolute top-0 right-0 h-full"
    />
  </div>
</template>

<script>
import firebase from "firebase/app"
import bgUrl from "@/assets/images/background-img.png"
import { mapGetters } from "vuex"

/**
 * Define the first integration page
 */
export default {
  // page state
  data() {
    return {
      // background image
      bgUrl,

      // integration options
      integrations: [
        {
          name: "hubspot"
        },
        {
          name: "salesforce"
        },
        {
          name: "mailing"
        }
      ]
    }
  },

  // unbind organization
  beforeDestroy() {
    this.$store.dispatch("orgs/unbindDoc")
  },

  // calculated props
  computed: {
    ...mapGetters({
      user: "users/getDoc",
      org: "orgs/getDoc"
    }),

    /**
     * Check if the user/org have active integrations
     */
    haveIntegrations() {
      console.log("this.user", this.user, "this.org", this.org)
      if (this.org?.hubspot?.api_key) return true
      else if ((this.user?.hubspot || {})[this.org?.id]) return true
      else if ((this.user?.salesforce || {})[this.org?.id]) return true
      else if ((this.user?.mailing || {})[this.org?.id]) return true
      else return false
    }
  },

  // watch props
  watch: {
    // bind org data
    user: {
      immediate: true,
      handler(user) {
        if (user) {
          let org = (user.orgs || [])[0]
          console.log("binding with org", org)
          if (org) {
            this.$store.dispatch("orgs/bindDoc", org)
          }
        }
      }
    },

    // check for integrations
    haveIntegrations: {
      immediate: true,
      handler(result) {
        if (result) {
          location.replace("/")
        }
      }
    }
  },

  // methods
  methods: {
    /**
     * signOut sign out the user from rele.ai.
     */
    async signOut() {
      // define auth and current user
      const fsAuth = firebase.auth()

      // signout and delete user
      await fsAuth.signOut()

      // reset state and redirect to auth
      this.$store.dispatch("reset")
      this.$router.replace("/auth")
    }
  }
}
</script>
